<template>
  <AsteonlineCard>
    <CardHead>
      {{ $t("auction.lot_list") }}
    </CardHead>
    <CardBody>
      <LotTabs
        :visible-tab="visibleTab"
        :auction="auction"
        @change-tab="visibleTab = $event"
      />

      <div v-if="visibleTab == 'standard'">
        <LotItem
          v-for="lot in auction.lots"
          :key="'auction-full-item-lotitem-' + lot.uuid"
          :lot="lot"
          :product-map="productMap"
          :show-if-bookmarked="onlyBookmark"
          :my-lot="authStore.canBid && auction.me ? auction.me.lots[lot.uuid] : null"
          :auction="auction"
          :is-outbid="lot.uuid == outbidLotUuid"
          @update-auction="$emit('update-auction', $event)"
        />
      </div>
      <div v-if="visibleTab == 'redistribute'">
        <div
          v-if="!auction.lotRedistributes || auction.lotRedistributes.length == 0"
          class="p-6 text-center text-lg"
        >
          {{ $t("auction.no_preemptions_available") }}
        </div>
        
        <LotItemRedistribute
          v-for="lot in auction.lotRedistributes"
          :key="'auction-full-item-lotitemredistribute-' + lot.uuid"
          :lot="lot"
          :product-map="productMap"
          :show-if-bookmarked="onlyBookmark"
          :my-lot="authStore.canBid && auction.me ? auction.me.lotRedistributes[lot.uuid] : null"
          :auction="auction"
          :is-outbid="lot.uuid == outbidLotUuid"
          @update-auction="$emit('update-auction', $event)"
        />
      </div>
    </CardBody>
  </AsteonlineCard>
</template>

<script setup>
import { ref } from 'vue';

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import LotItem from '@/components/lot/LotItem.vue';
import LotItemRedistribute from '@/components/lot/LotItemRedistribute.vue';
import LotTabs from '@/components/lot/LotTabs.vue';
import { useAuthStore } from '@/stores/auth';
const emit = defineEmits(['update-auction'])

const props = defineProps({
    auction: {
        type: Object,
        required: true
    },
    productMap: {
        type: Object,
        required: true
    },
    onlyBookmark: {
        type: Boolean,
        required: true
    },
    outbidLotUuid: {
        type: String,
        required: false,
        default: null
    }
})

const authStore = useAuthStore();

const visibleTab = ref(
    props.auction.auctionStatus == 'REDISTRIBUTING_1' || props.auction.auctionStatus == 'REDISTRIBUTING_2' ? 
    'redistribute' : 
    'standard'
);
</script>